import { useQuery } from '@tanstack/react-query';
import { getMainCatsClient } from '@util/firestore/categories';

const useMainCats = () => {
  const { data: mainCats } = useQuery({
    queryKey: ['mainCats'],
    queryFn: () => getMainCatsClient(),
  });

  if (!mainCats) return [];
  return mainCats;
};

export default useMainCats;
